import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

/**
 * Functional HTTP interceptor — attaches the Bearer JWT to every /api request.
 * Register with: provideHttpClient(withInterceptors([authInterceptor]))
 */
export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const authService = inject(AuthService);
  const token = authService.getToken();

  if (token && isApiRequest(req.url)) {
    return next(
      req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) }),
    );
  }
  return next(req);
};

function isApiRequest(url: string): boolean {
  if (url.startsWith('/api')) {
    return true;
  }

  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const parsed = new URL(url, window.location.origin);
    const isApiPath = parsed.pathname.startsWith('/api');
    const isLocalApiHost =
      parsed.hostname === window.location.hostname && parsed.port === '3000';

    return isApiPath && isLocalApiHost;
  } catch {
    return false;
  }
}

